import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import ProductsDashboard from '@/views/products/Dashboard.vue'
import ProductView from '@/views/products/Product.vue'

import CustomerList from '@/views/admin/CustomerList.vue'
import ProductList from '@/views/admin/ProductList.vue'
import LoginList from '@/views/admin/LoginList.vue'
import JobList from '@/views/admin/JobList.vue'
import AccountDashboard from '@/views/account/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: ProductsDashboard
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/account',
    name: 'My Account',
    component: AccountDashboard
  },
  {
    path: '/admin/customers',
    name: 'CustomerList',
    component: CustomerList
  },
  {
    path: '/admin/jobs',
    name: 'JobList',
    component: JobList
  },
  {
    path: '/admin/customers/:id/products',
    name: 'ProductList',
    component: ProductList
  },
  {
    path: '/products/:id',
    name: 'ProductView',
    component: ProductView
  },
  {
    path: '/admin/logins/:id',
    name: 'LoginList',
    component: LoginList
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
